import React, { useState, useEffect, useRef } from "react";
import StackedBarChart from "../../Atoms/CustomComponets/StackedBarChart";
import InhalerCard from "../../Atoms/CustomComponets/InhalerCard";
import CoughCard from "../../Atoms/CustomComponets/CoughCard";
import StackedByType from "../../Atoms/CustomComponets/StackedByType";
import {
  Alert,
  Button,
  Chip,
  CircularProgress,
  Divider,
  IconButton,
  LinearProgress,
  Skeleton,
  Snackbar,
  Stack,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  Details,
  SentimentVeryDissatisfied,
  Info,
} from "@mui/icons-material";
import AudiosBox from "../../Atoms/CustomComponets/AudiosBox";
import { Link, useNavigate, useParams } from "react-router-dom";
import GetData from "../../API/GetData";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  MonthCalendar,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import No_chartsData from "../../Assets/Images/NoDataIcons/No_chartsData.svg";
import No_AudioData from "../../Assets/Images/NoDataIcons/No_AudioData.svg";
import Joyride from "react-joyride";
import SimpleBarChart from "../../Atoms/CustomComponets/SimpleBarChart";

export default function Index(props) {
  // Destructuring props
  const {
    setOpenResToPat,
    setPatDetail,
    patDetail,
    filterBy,
    setfilterBy,
    selectedDate,
    setselectedDate,
    inhalerselectedDate,
    setinhalerselectedDate,
    tourStart,
  } = props;

  // Other state variables
  const { user_id } = useParams();
  const [slotBy, setslotBy] = useState("");
  const [audioData, setaudioData] = useState([]);
  const [InhalerValuesData, setInhalerValuesData] = useState([]);
  const [autoselectedDate, setautoselectedDate] = useState("");
  const [inhalerautoselectedDate, setinhalerautoselectedDate] = useState("");
  const [intensityPlot, setIntensityPlot] = useState([]);
  const [typePlot, setTypePlot] = useState([]);
  const [inhalerCount, setInhalerCount] = useState([]);
  const [dateHour, setDateHour] = useState("");
  const [IntensCoughTracked, setIntensCoughTracked] = useState("");
  const [message, setMessage] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");
  const [sendingReq, setsendingReq] = useState(false);
  const [sendingAudioReq, setsendingAudioReq] = useState(false);
  const [sendingInhalerReq, setsendingInhalerReq] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const data_type = ["rec_intensity", "rec_type"];

  // Function to convert UTC to local time zone
  const utcToTimeZone = (params, format = "YYYY-MM-DD HH:mm:ss") => {
    return moment.utc(params).local().format(format);
  };

  useEffect(() => {
    GetData.UserDetail(user_id).then((res) => {
      res = res.data;
      setPatDetail(res);
    });
  }, []);

  useEffect(() => {
    if (!selectedDate) {
      setTypePlot([]);
      setIntensityPlot([]);
      setsendingReq(true);
      const data_type = "rec_intensity";
      GetData.TypePlotData(user_id, data_type, filterBy).then((res) => {
        res = res.data;
        setIntensityPlot(res.data);
        const datetime = utcToTimeZone(res.value);
        // setautoselectedDate(utcToTimeZone(res.value));
        setautoselectedDate(datetime);
        setIntensCoughTracked(res.cough_tracked);
        setsendingReq(false);
      });
    }
  }, [filterBy]);

  useEffect(() => {
    if (slotBy) {
      setTypePlot([]);
      setIntensityPlot([]);
      setsendingReq(true);
      const data_type = "rec_intensity";
      GetData.TypePlotDataSlot(
        user_id,
        data_type,
        filterBy,
        slotBy,
        autoselectedDate
      ).then((res) => {
        res = res.data;
        setIntensityPlot(res.data);
        const datetime = utcToTimeZone(res.value);
        // setautoselectedDate(utcToTimeZone(res.value));
        setautoselectedDate(datetime);
        setIntensCoughTracked(res.cough_tracked);
        setslotBy("");
        setsendingReq(false);
        setTotalCount(res.total_count);
      });
    }
  }, [slotBy]);
  console.log(autoselectedDate, "autoselectedDate");
  useEffect(() => {
    if (selectedDate) {
      setTypePlot([]);
      setIntensityPlot([]);
      setsendingReq(true);
      const data_type = "rec_intensity";
      GetData.TypePlotDatato(user_id, data_type, filterBy, selectedDate).then(
        (res) => {
          res = res.data;
          setIntensityPlot(res.data);
          const datetime = utcToTimeZone(res.value);
          // setautoselectedDate(utcToTimeZone(res.value));
          setautoselectedDate(datetime);
          setIntensCoughTracked(res.cough_tracked);
          setselectedDate("");
          setsendingReq(false);
          setTotalCount(res.total_count);
        }
      );
    }
  }, [selectedDate]);

  useEffect(() => {
    if (!selectedDate) {
      setInhalerCount([]);
      setsendingReq(true);
      GetData.TypeInhalerData(user_id, data_type, filterBy).then((res) => {
        res = res.data;
        setinhalerautoselectedDate(res.value);
        setInhalerCount(res.data);
        setsendingReq(false);
        setTotalCount(res.total_count);
      });
    }
  }, [filterBy]);

  useEffect(() => {
    if (slotBy) {
      setInhalerCount([]);
      setsendingReq(true);
      GetData.TypeInhalerDataSlot(
        user_id,
        data_type,
        filterBy,
        slotBy,
        inhalerautoselectedDate
      ).then((res) => {
        res = res.data;
        setInhalerCount(res.data);
        setinhalerautoselectedDate(res.value);
        setslotBy("");
        setsendingReq(false);
      });
    }
  }, [slotBy]);

  useEffect(() => {
    if (selectedDate) {
      setInhalerCount([]);
      setsendingReq(true);
      GetData.TypeInhalerDatato(
        user_id,
        data_type,
        filterBy,
        selectedDate
      ).then((res) => {
        res = res.data;
        setInhalerCount(res.data);
        setinhalerautoselectedDate(res.value);
        setinhalerselectedDate("");
        setsendingReq(false);
      });
    }
  }, [selectedDate]);

  function fullDate(params) {
    const date = new Date(params);
    const yyyy = date.getFullYear();
    const yy = yyyy.toString();
    const y = yy.slice(2, 4);
    let mm = date.toLocaleString("default", { month: "short" });
    let dd = date.getDate();
    if (dd < 10) dd = "0" + dd;
    return dd + "-" + mm + "-" + y;
  }

  const detailTourSteps = [
    {
      target: "#patient-details-summary",
      content:
        "Shows patient's details summary, that includes patient's name, registered date, recorded hours, No. of recorded Coughs and Severity Level of the particular Patient",
    },
    {
      target: "#graph-filters",
      content:
        "Here you can filter the graph by selecting the time span as 'Hourly', 'Weekly' and 'Daily'. You can also Use arrows to move 'To' and 'Fro' with respect to the selected filter.",
    },
    {
      target: "#graph-summary",
      content:
        "Here Doctor can visualise the summary of the recent graph, which includes total coughs in that particular span and the cough rate.",
    },
    {
      target: "#chart",
      content:
        "Cough Plot by Loudness as High and Low. Cough Plot by Type as Wet and Dry.",
    },
  ];

  return (
    <div className="container px-0 px-md-4">
      <Joyride
        steps={detailTourSteps}
        run={tourStart}
        continuous={true}
        showProgress={true}
        showSkipButton={true}
        showStepsProgress={true}
        disableScrollParentFix={true}
      />
      <h1 className="p-2 Roboto-bold">Patient Details</h1>
      <div className="grid-5 info-card" id="patient-details-summary">
        <div className="p-3">
          <div className="d-flex flex-column text-center brdr-right">
            <p className="text-primry fw-700 fs-18 Roboto">
              {patDetail?.user_info_id ? patDetail.user_info_id : "-"}
            </p>
            <p className="fs-16">Patient No.</p>
          </div>
        </div>
        <div className="p-3">
          <div className="d-flex flex-column text-center brdr-right">
            <p className="text-primry fw-700 fs-18 Roboto">
              {patDetail?.name ? patDetail.name : "-"}
            </p>
            <p className="fs-16">Patient Name</p>
          </div>
        </div>
        <div className="p-3">
          <div className="d-flex flex-column text-center brdr-right">
            <p className="text-primry fw-700 fs-18 Roboto">
              {patDetail?.register ? fullDate(patDetail.register) : "-"}
            </p>
            <p className="fs-16">Registered Since</p>
          </div>
        </div>
        <div className="p-3">
          <div className="d-flex flex-column text-center brdr-right">
            <p className="text-primry fw-700 fs-18 Roboto">
              {patDetail?.no_cough ? patDetail.no_cough : "0"}
            </p>
            <p className="fs-16">No. of Coughs Recorded</p>
          </div>
        </div>
        <div className="p-3">
          <div className="d-flex flex-column text-center">
            <p className="text-primry fw-700 fs-18 Roboto">
              {patDetail.recording_count}
            </p>
            <p className="fs-16">No. of Times Inhaler is Used</p>
          </div>
        </div>
      </div>
      <div className="info-card my-4">
        <div className="row my-4" id="graph-filters">
          <div className="col-12 col-sm-6 col-md-9 text-center text-md-end my-auto">
            <Chip
              label="Hourly"
              variant={filterBy == "hourly" ? "filled" : "outlined"}
              onClick={() => setfilterBy("hourly")}
              className={`fs-16 px-3 chip-styles ${
                filterBy == "hourly" && "selected-button"
              }`}
            />
            <Chip
              label="Daily"
              variant={filterBy == "daily" ? "filled" : "outlined"}
              onClick={() => setfilterBy("daily")}
              className={`fs-16 px-3 ms-3 chip-styles ${
                filterBy == "daily" && "selected-button"
              }`}
            />
            <Chip
              label="Weekly"
              variant={filterBy == "weekly" ? "filled" : "outlined"}
              onClick={() => setfilterBy("weekly")}
              className={`fs-16 px-3 ms-3 chip-styles ${
                filterBy == "weekly" && "selected-button"
              }`}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-3 text-center">
            <span className="brdr-right mx-5 d-none d-md-block"></span>
            <IconButton
              aria-label="back"
              style={{
                boxShadow: "#00000066 0px 2px 10px 0px",
              }}
              onClick={() => setslotBy("prev")}
            >
              <ArrowBack />
            </IconButton>
            <span
              label="0"
              variant="text"
              className="fs-16 px-3 mx-2 text-primry fw-500"
            >
              {filterBy == "hourly"
                ? `${moment(autoselectedDate).format("MMM DD, YYYY  HH:mm a")}`
                : filterBy == "daily"
                ? `${moment(autoselectedDate).format("MMM DD ,YYYY")}`
                : `Week ${
                    moment(autoselectedDate, "YYYY-MM-DD").week() -
                    moment(autoselectedDate, "YYYY-MM-DD")
                      .startOf("month")
                      .week() +
                    1
                  } of ${moment(autoselectedDate).format("MMM, YYYY")}`}
            </span>
            <IconButton
              aria-label="forward"
              style={{
                boxShadow: "#00000066 0px 2px 10px 0px",
              }}
              onClick={() => setslotBy("next")}
            >
              <ArrowForward />
            </IconButton>
            {sendingReq ? (
              <LinearProgress className="w-25 mx-auto text-primry" />
            ) : (
              <p className="w-25 mx-auto brdr-bottom"></p>
            )}
          </div>
        </div>
        <div key={1} className="position-relative">
          {sendingReq && (
            <div class="text-center d-flex h-100 flex-column absolute-center-loader transition-loading">
              <div class="my-auto">
                <CircularProgress />
                <p className="fs-16 fw-500 text-center text-dark my-3">
                  Loading...
                </p>
              </div>
            </div>
          )}
          {!sendingReq && intensityPlot.length === 0 && (
            <div class="text-center d-flex h-100 flex-column absolute-center-noData transition-loading">
              <div class="my-auto">
                <img src={No_chartsData} />
                <p className="fs-16 fw-500 text-center text-dark my-3">
                  No Graph Available
                </p>
              </div>
            </div>
          )}
          <h1 className="p-3 Roboto-bold">Cough</h1>
          <div className="row my-4">
            <div className="col-md-9">
              <StackedBarChart
                filterBy={filterBy}
                setfilterBy={setfilterBy}
                user_id={user_id}
                setselectedDate={setselectedDate}
                autoselectedDate={autoselectedDate}
                data={intensityPlot}
                fixedData={intensityPlot}
                setaudioData={setaudioData}
                setsendingAudioReq={setsendingAudioReq}
                ChartNo={1}
                sendingReq={sendingReq}
                utcToTimeZone={utcToTimeZone}
              />
            </div>
            <div className="col-md-3 h-75 p-5">
              <CoughCard
                totalCount={totalCount}
                filterBy={filterBy}
                data={intensityPlot}
              />
            </div>
          </div>
        </div>
        <div className="position-relative">
          {sendingReq && (
            <div class="text-center d-flex h-100 flex-column absolute-center-loader transition-loading">
              <div class="my-auto">
                <CircularProgress />
                <p className="fs-16 fw-500 text-center text-dark my-3">
                  Loading...
                </p>
              </div>
            </div>
          )}
          {!sendingReq && inhalerCount.length === 0 && (
            <div class="text-center d-flex h-100 flex-column absolute-center-noData transition-loading">
              <div class="my-auto">
                <img src={No_chartsData} />
                <p className="fs-16 fw-500 text-center text-dark my-3">
                  No Graph Available
                </p>
              </div>
            </div>
          )}
          <h1 className="p-3 Roboto-bold">Inhaler</h1>
          <div className="row h-100 my-4">
            <div className="col-md-9">
              <SimpleBarChart
                filterBy={filterBy}
                setfilterBy={setfilterBy}
                user_id={user_id}
                setselectedDate={setinhalerselectedDate}
                autoselectedDate={inhalerautoselectedDate}
                data={inhalerCount}
                fixedData={inhalerCount}
                setInhalerValuesData={setInhalerValuesData}
                setsendingInhalerReq={setsendingInhalerReq}
                ChartNo={2}
                sendingReq={sendingReq}
              />
            </div>
            <div className="col-md-3 h-75 p-5">
              <InhalerCard totalCount={totalCount} filterBy={filterBy} />
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={message ? true : ErrorMessage ? true : false}
        onClose={() => {
          setMessage("");
          setErrorMessage("");
        }}
      >
        <Alert
          severity={ErrorMessage ? "warning" : message && "success"}
          autohideduration={3000}
          sx={{ width: 500, fontSize: "18px" }}
        >
          {message || ErrorMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}
